// import Vue from "vue";
// import VueAwesomeSwiper from "vue-awesome-swiper";
//
// import "swiper/swiper.scss";
//
// Vue.use(VueAwesomeSwiper);
import Vue from "vue";
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.css";
SwiperClass.use([Pagination, Mousewheel, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
